import Vue from 'vue'
import Vuex from 'vuex'

import { sitPedidos } from "./modules/sit-pedidos"
import { siePedidos } from "@/store/modules/sie-pedidos";
import { gessan } from "@/store/modules/gessan";

import { spgc } from './modules/spgc';


Vue.use(Vuex)

export default new Vuex.Store({
  strict: false,
  modules: {
    sitPedidos,
    siePedidos,
    gessan,
    spgc
  }
})
